// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-page {
  --about-type-heading: clamp(2rem, 3vw, 3rem);
  --about-type-subheading: clamp(1.5rem, 2.2vw, 2.15rem);
  --about-type-card-heading: 1.35rem;
  --about-type-body: 1.1rem;
  --about-type-body-lg: 1.2rem;
  min-height: 100vh;
  background: #ece4ed;
  color: #370b3b;
  font-family: 'Inter', system-ui, sans-serif;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  padding: 2.5rem 0.6rem 3rem;
}

.about-hero,
.about-block,
.about-quote,
.about-philosophy {
  width: min(1220px, 100%);
  margin: 0 auto;
}

.about-hero {
  background: #ffffff;
  border: 1px solid rgba(55, 11, 59, 0.12);
  border-radius: 16px;
  padding: 1.5rem 1.35rem;
}

.about-eyebrow {
  margin: 0 0 0.6rem;
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: #370b3b;
}

.about-hero h1 {
  margin: 0 0 0.85rem;
  font-size: var(--about-type-heading);
  line-height: 1.3;
  color: #111827;
}

.about-hero p {
  margin: 0;
  line-height: 1.75;
  font-size: var(--about-type-body-lg);
  color: #334155;
}

.about-block {
  background: #ffffff;
  border: 1px solid rgba(55, 11, 59, 0.1);
  border-radius: 16px;
  padding: 1.3rem 1.35rem;
}

.about-block h2 {
  margin: 0 0 0.8rem;
  font-size: var(--about-type-subheading);
  color: #370b3b;
}

.about-block p {
  margin: 0 0 0.9rem;
  line-height: 1.8;
  font-size: var(--about-type-body);
  color: #334155;
}

.about-block p:last-child {
  margin-bottom: 0;
}

.about-highlight {
  margin: 0;
  font-weight: 700;
  color: #370b3b;
  font-size: var(--about-type-body);
}

.about-philosophy {
  display: flex;
  flex-direction: column;
  gap: 1.3rem;
}

.about-pillars {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1.1rem;
}

.about-pillar {
  background: #f3edf7;
  border-radius: 24px;
  padding: 1.7rem 1.4rem;
  text-align: center;
  border: 1px solid rgba(55, 11, 59, 0.08);
}

.about-pillar-icon {
  width: 72px;
  height: 72px;
  border-radius: 999px;
  margin: 0 auto 1rem;
  background: #e8d8f1;
  color: #370b3b;
  display: grid;
  place-items: center;
  font-size: 2rem;
  font-weight: 700;
}

.about-pillar h3 {
  margin: 0 0 0.7rem;
  font-size: var(--about-type-card-heading);
  color: #370b3b;
  line-height: 1.25;
}

.about-pillar p {
  margin: 0;
  color: #4b5563;
  font-size: var(--about-type-body);
  line-height: 1.55;
}

.about-pillar--featured {
  background: #370b3b;
  color: #ffffff;
  border-color: rgba(255, 255, 255, 0.2);
  box-shadow: 0 20px 34px rgba(55, 11, 59, 0.32);
}

.about-pillar--featured .about-pillar-icon {
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}

.about-pillar--featured h3,
.about-pillar--featured p {
  color: #ffffff;
}

.about-philosophy-panel {
  border-radius: 30px;
  padding: 2.3rem 2.5rem;
  background:
    radial-gradient(circle at 0% 100%, rgba(255, 255, 255, 0.08) 0 18%, transparent 19%),
    radial-gradient(circle at 95% 8%, rgba(255, 255, 255, 0.09) 0 16%, transparent 17%),
    linear-gradient(125deg, #370b3b, #370b3b);
  color: #ffffff;
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 1.5rem;
  align-items: center;
}

.about-philosophy-label {
  margin: 0 0 0.65rem;
  letter-spacing: 0.24em;
  font-size: 1.05rem;
  color: rgba(255, 255, 255, 0.72);
}

.about-philosophy-copy h3 {
  margin: 0;
  font-size: var(--about-type-heading);
  line-height: 1.15;
  color: #f59e0b;
}

.about-philosophy-sub {
  margin: 0.8rem 0 0.4rem;
  color: rgba(255, 255, 255, 0.75);
  font-style: italic;
  font-size: var(--about-type-subheading);
}

.about-philosophy-divider {
  width: 82px;
  height: 5px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.42);
  margin: 1rem 0 1.1rem;
}

.about-philosophy-text {
  margin: 0;
  color: rgba(255, 255, 255, 0.94);
  font-size: var(--about-type-body-lg);
  line-height: 1.6;
}

.about-philosophy-text strong {
  color: #f59e0b;
}

.about-philosophy-orbit {
  display: grid;
  place-items: center;
  gap: 0.85rem;
}

.about-philosophy-rings {
  width: 180px;
  height: 180px;
  border-radius: 999px;
  position: relative;
  display: grid;
  place-items: center;
}

.about-philosophy-ring {
  border: 5px solid rgba(255, 255, 255, 0.2);
  border-radius: 999px;
  position: absolute;
}

.about-philosophy-ring--outer {
  width: 172px;
  height: 172px;
}

.about-philosophy-ring--inner {
  width: 104px;
  height: 104px;
}

.about-philosophy-core {
  width: 62px;
  height: 62px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.22);
  display: grid;
  place-items: center;
  font-size: 2rem;
}

.about-philosophy-orbit p {
  margin: 0;
  text-align: center;
  color: rgba(255, 255, 255, 0.77);
  line-height: 1.45;
  font-size: var(--about-type-body);
}

.about-quote {
  background: #370b3b;
  border-radius: 16px;
  padding: 1.35rem 1.35rem;
}

.about-quote p {
  margin: 0;
  text-align: center;
  color: #f59e0b;
  font-size: var(--about-type-subheading);
  line-height: 1.9;
  font-weight: 600;
}

.about-closing {
  margin: 0;
  font-weight: 700;
  color: #370b3b;
  font-size: var(--about-type-subheading);
}

@media (max-width: 640px) {
  .about-page {
    padding: 1.6rem 0.9rem 2rem;
  }

  .about-pillars {
    grid-template-columns: 1fr;
  }

  .about-philosophy-panel {
    grid-template-columns: 1fr;
    padding: 1.6rem 1.2rem;
    border-radius: 24px;
  }

  .about-philosophy-copy h3 {
    font-size: 2rem;
  }

  .about-philosophy-text {
    font-size: 1.2rem;
  }

  .about-philosophy-rings {
    width: 144px;
    height: 144px;
  }

  .about-philosophy-ring--outer {
    width: 136px;
    height: 136px;
  }

  .about-philosophy-ring--inner {
    width: 84px;
    height: 84px;
  }

  .about-quote p {
    font-size: 1.05rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/frontend/pages/About/about.css"],"names":[],"mappings":"AAAA;EACE,4CAA4C;EAC5C,sDAAsD;EACtD,kCAAkC;EAClC,yBAAyB;EACzB,4BAA4B;EAC5B,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;;;;EAIE,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB;;;6CAG2C;EAC3C,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,uCAAuC;EACvC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".about-page {\r\n  --about-type-heading: clamp(2rem, 3vw, 3rem);\r\n  --about-type-subheading: clamp(1.5rem, 2.2vw, 2.15rem);\r\n  --about-type-card-heading: 1.35rem;\r\n  --about-type-body: 1.1rem;\r\n  --about-type-body-lg: 1.2rem;\r\n  min-height: 100vh;\r\n  background: #ece4ed;\r\n  color: #370b3b;\r\n  font-family: 'Inter', system-ui, sans-serif;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1.25rem;\r\n  padding: 2.5rem 0.6rem 3rem;\r\n}\r\n\r\n.about-hero,\r\n.about-block,\r\n.about-quote,\r\n.about-philosophy {\r\n  width: min(1220px, 100%);\r\n  margin: 0 auto;\r\n}\r\n\r\n.about-hero {\r\n  background: #ffffff;\r\n  border: 1px solid rgba(55, 11, 59, 0.12);\r\n  border-radius: 16px;\r\n  padding: 1.5rem 1.35rem;\r\n}\r\n\r\n.about-eyebrow {\r\n  margin: 0 0 0.6rem;\r\n  font-size: 0.95rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.09em;\r\n  text-transform: uppercase;\r\n  color: #370b3b;\r\n}\r\n\r\n.about-hero h1 {\r\n  margin: 0 0 0.85rem;\r\n  font-size: var(--about-type-heading);\r\n  line-height: 1.3;\r\n  color: #111827;\r\n}\r\n\r\n.about-hero p {\r\n  margin: 0;\r\n  line-height: 1.75;\r\n  font-size: var(--about-type-body-lg);\r\n  color: #334155;\r\n}\r\n\r\n.about-block {\r\n  background: #ffffff;\r\n  border: 1px solid rgba(55, 11, 59, 0.1);\r\n  border-radius: 16px;\r\n  padding: 1.3rem 1.35rem;\r\n}\r\n\r\n.about-block h2 {\r\n  margin: 0 0 0.8rem;\r\n  font-size: var(--about-type-subheading);\r\n  color: #370b3b;\r\n}\r\n\r\n.about-block p {\r\n  margin: 0 0 0.9rem;\r\n  line-height: 1.8;\r\n  font-size: var(--about-type-body);\r\n  color: #334155;\r\n}\r\n\r\n.about-block p:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.about-highlight {\r\n  margin: 0;\r\n  font-weight: 700;\r\n  color: #370b3b;\r\n  font-size: var(--about-type-body);\r\n}\r\n\r\n.about-philosophy {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1.3rem;\r\n}\r\n\r\n.about-pillars {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, minmax(0, 1fr));\r\n  gap: 1.1rem;\r\n}\r\n\r\n.about-pillar {\r\n  background: #f3edf7;\r\n  border-radius: 24px;\r\n  padding: 1.7rem 1.4rem;\r\n  text-align: center;\r\n  border: 1px solid rgba(55, 11, 59, 0.08);\r\n}\r\n\r\n.about-pillar-icon {\r\n  width: 72px;\r\n  height: 72px;\r\n  border-radius: 999px;\r\n  margin: 0 auto 1rem;\r\n  background: #e8d8f1;\r\n  color: #370b3b;\r\n  display: grid;\r\n  place-items: center;\r\n  font-size: 2rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.about-pillar h3 {\r\n  margin: 0 0 0.7rem;\r\n  font-size: var(--about-type-card-heading);\r\n  color: #370b3b;\r\n  line-height: 1.25;\r\n}\r\n\r\n.about-pillar p {\r\n  margin: 0;\r\n  color: #4b5563;\r\n  font-size: var(--about-type-body);\r\n  line-height: 1.55;\r\n}\r\n\r\n.about-pillar--featured {\r\n  background: #370b3b;\r\n  color: #ffffff;\r\n  border-color: rgba(255, 255, 255, 0.2);\r\n  box-shadow: 0 20px 34px rgba(55, 11, 59, 0.32);\r\n}\r\n\r\n.about-pillar--featured .about-pillar-icon {\r\n  background: rgba(255, 255, 255, 0.2);\r\n  color: #ffffff;\r\n}\r\n\r\n.about-pillar--featured h3,\r\n.about-pillar--featured p {\r\n  color: #ffffff;\r\n}\r\n\r\n.about-philosophy-panel {\r\n  border-radius: 30px;\r\n  padding: 2.3rem 2.5rem;\r\n  background:\r\n    radial-gradient(circle at 0% 100%, rgba(255, 255, 255, 0.08) 0 18%, transparent 19%),\r\n    radial-gradient(circle at 95% 8%, rgba(255, 255, 255, 0.09) 0 16%, transparent 17%),\r\n    linear-gradient(125deg, #370b3b, #370b3b);\r\n  color: #ffffff;\r\n  display: grid;\r\n  grid-template-columns: 2fr 1fr;\r\n  gap: 1.5rem;\r\n  align-items: center;\r\n}\r\n\r\n.about-philosophy-label {\r\n  margin: 0 0 0.65rem;\r\n  letter-spacing: 0.24em;\r\n  font-size: 1.05rem;\r\n  color: rgba(255, 255, 255, 0.72);\r\n}\r\n\r\n.about-philosophy-copy h3 {\r\n  margin: 0;\r\n  font-size: var(--about-type-heading);\r\n  line-height: 1.15;\r\n  color: #f59e0b;\r\n}\r\n\r\n.about-philosophy-sub {\r\n  margin: 0.8rem 0 0.4rem;\r\n  color: rgba(255, 255, 255, 0.75);\r\n  font-style: italic;\r\n  font-size: var(--about-type-subheading);\r\n}\r\n\r\n.about-philosophy-divider {\r\n  width: 82px;\r\n  height: 5px;\r\n  border-radius: 999px;\r\n  background: rgba(255, 255, 255, 0.42);\r\n  margin: 1rem 0 1.1rem;\r\n}\r\n\r\n.about-philosophy-text {\r\n  margin: 0;\r\n  color: rgba(255, 255, 255, 0.94);\r\n  font-size: var(--about-type-body-lg);\r\n  line-height: 1.6;\r\n}\r\n\r\n.about-philosophy-text strong {\r\n  color: #f59e0b;\r\n}\r\n\r\n.about-philosophy-orbit {\r\n  display: grid;\r\n  place-items: center;\r\n  gap: 0.85rem;\r\n}\r\n\r\n.about-philosophy-rings {\r\n  width: 180px;\r\n  height: 180px;\r\n  border-radius: 999px;\r\n  position: relative;\r\n  display: grid;\r\n  place-items: center;\r\n}\r\n\r\n.about-philosophy-ring {\r\n  border: 5px solid rgba(255, 255, 255, 0.2);\r\n  border-radius: 999px;\r\n  position: absolute;\r\n}\r\n\r\n.about-philosophy-ring--outer {\r\n  width: 172px;\r\n  height: 172px;\r\n}\r\n\r\n.about-philosophy-ring--inner {\r\n  width: 104px;\r\n  height: 104px;\r\n}\r\n\r\n.about-philosophy-core {\r\n  width: 62px;\r\n  height: 62px;\r\n  border-radius: 999px;\r\n  background: rgba(255, 255, 255, 0.22);\r\n  display: grid;\r\n  place-items: center;\r\n  font-size: 2rem;\r\n}\r\n\r\n.about-philosophy-orbit p {\r\n  margin: 0;\r\n  text-align: center;\r\n  color: rgba(255, 255, 255, 0.77);\r\n  line-height: 1.45;\r\n  font-size: var(--about-type-body);\r\n}\r\n\r\n.about-quote {\r\n  background: #370b3b;\r\n  border-radius: 16px;\r\n  padding: 1.35rem 1.35rem;\r\n}\r\n\r\n.about-quote p {\r\n  margin: 0;\r\n  text-align: center;\r\n  color: #f59e0b;\r\n  font-size: var(--about-type-subheading);\r\n  line-height: 1.9;\r\n  font-weight: 600;\r\n}\r\n\r\n.about-closing {\r\n  margin: 0;\r\n  font-weight: 700;\r\n  color: #370b3b;\r\n  font-size: var(--about-type-subheading);\r\n}\r\n\r\n@media (max-width: 640px) {\r\n  .about-page {\r\n    padding: 1.6rem 0.9rem 2rem;\r\n  }\r\n\r\n  .about-pillars {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .about-philosophy-panel {\r\n    grid-template-columns: 1fr;\r\n    padding: 1.6rem 1.2rem;\r\n    border-radius: 24px;\r\n  }\r\n\r\n  .about-philosophy-copy h3 {\r\n    font-size: 2rem;\r\n  }\r\n\r\n  .about-philosophy-text {\r\n    font-size: 1.2rem;\r\n  }\r\n\r\n  .about-philosophy-rings {\r\n    width: 144px;\r\n    height: 144px;\r\n  }\r\n\r\n  .about-philosophy-ring--outer {\r\n    width: 136px;\r\n    height: 136px;\r\n  }\r\n\r\n  .about-philosophy-ring--inner {\r\n    width: 84px;\r\n    height: 84px;\r\n  }\r\n\r\n  .about-quote p {\r\n    font-size: 1.05rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
